import { useQuery } from "@tanstack/react-query"
import { segmentGroupShopifyMetricsQuery } from "../lib/segmentGroupShopifyMetricsQuery"

export function useSegmentGroupShopifyMetricsQuery(
  ...args: Parameters<typeof segmentGroupShopifyMetricsQuery>
) {
  return useQuery(segmentGroupShopifyMetricsQuery(...args))
}
